/**
 * Simplified DevTools middleware for Zustand stores
 * Provides basic Redux DevTools integration for debugging
 */

import { StateCreator } from 'zustand'
import { devtools } from 'zustand/middleware'

/**
 * Development-only DevTools middleware
 * Only enables DevTools in development mode
 */
export const devtoolsDev = <T>(stateCreator: StateCreator<T>, name?: string) => 
  devtools(stateCreator, { 
    name: name || 'ZustandStore',
    enabled: process.env.NODE_ENV === 'development' 
  })

/**
 * Creates a named DevTools middleware
 * @param name - Store name for DevTools
 * @returns DevTools middleware function
 */
export function createDevtools(name: string) {
  return <T>(stateCreator: StateCreator<T>) => devtools(stateCreator, { name })
}